// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  color: rgb(155, 156, 158);
  font-size: 12px;
}

.tab-container1 {
  display: flex;
  border-bottom: 1px solid rgb(78, 78, 78);
  height: 40px;
  margin-bottom: 20px; /* Adjust as needed */
  gap: 20px;
}

.tab-container {
  display: flex;
  justify-content: center;
  height: 30px;
  margin-bottom: 20px; /* Adjust as needed */
  gap: 20px;
}

.tab {
  display: flex;
  align-items: center;
  justify-content: center; /* Center align text and icons */
  cursor: pointer;
  padding-bottom: 2px;
  transition: border-bottom 0.3s ease-in-out;
  width: auto; /* Adjust width to fit content */
  padding: 0 15px; /* Add padding to make it larger */
  text-align: center; /* Center align text */
}

.tab1 {
  display: flex;
  align-items: center;
  justify-content: center; /* Center align text and icons */
  cursor: pointer;
  padding-bottom: 2px;
  transition: border-bottom 0.3s ease-in-out;
  width: auto; /* Adjust width to fit content */
  padding: 0 15px; /* Add padding to make it larger */
  text-align: center; /* Center align text */
}

.tab:last-child {
  margin-right: 0;
  padding-right: 10px;
  padding-left: 0px;
}

.tab-icon {
  margin-right: 5px;
}

.library-icon {
  margin-right: 0px;
  margin-top: 20px; /* Removed margin-top to align with other tab */
}

.active {
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(to right, rgb(246, 106, 75) 0%, rgb(246, 106, 75) 30%, rgb(162, 74, 231) 60%, rgb(72, 89, 243) 100%) 1;
  border-image-slice: 1;
}

.active1 {
  border-bottom: 2px solid #A100FF;
  border-image-slice: 1;
}

.chat-content,
.library-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /* Additional styles for content */
}

/* Responsive design for tabs */
@media (min-width: 768px) {
  .tab {
    width: auto; /* Tabs will now expand and fill the space */
  }
}
.chat-messages {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow-y: scroll;
  height: 54vh;
  padding-left: 6%;
}

.message-row {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(161, 161, 161);
}

.message-row.user-message {
  border-bottom: none;
  padding-bottom: 0;
}

.message-content {
  width: 65%;
  margin-right: 30px;
}

.message-info {
  display: flex;
  flex-direction: row;
  margin-top: 1%;
  border: 1px solid #4E4E4E;
  border-radius: 10px;
  padding-top: 1%;
  align-items: flex-start;
}

.avatar {
  width: 30px;
  padding-left: 10px;
  margin-top: 5px;
}

.sender-name {
  margin-left: 2%;
  color: rgb(155, 156, 158);
  font-size: 12px;
  margin-top: 5px;
}

.formatted-message {
  color: white;
}

.message-text {
  padding: 5px 0;
  font-size: 10px;
  text-align: left;
  font-family: Graphik;
}

.message-meta {
  width: 30%;
}

.accordions {
  margin-top: -55px;
  max-height: 45vh;
  overflow-y: scroll;
}

.meta-accordion {
  margin-bottom: 10px;
  background-color: rgb(43, 44, 51);
}

.accordion-title {
  font-size: 10px;
  text-align: center;
  font-family: Graphik;
}

.expand-button {
  background: none;
  border: none;
  margin-left: 250px;
}

.document-button {
  background: linear-gradient(to right, rgb(246, 106, 75) 0%, rgb(246, 106, 75) 30%, rgb(162, 74, 231) 60%, rgb(72, 89, 243) 100%);
  font-size: 10px;
  border: 1px solid rgb(26, 29, 33);
  border-radius: 15px;
  color: white;
  margin: 2px;
  padding: 5px 10px; /* Adjust padding as needed */
  cursor: pointer; /* Add cursor pointer for interaction */
}

.recommendation-text {
  font-size: 10px;
  color: white;
}

.input-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  padding: 10px;
  justify-content: center;
  align-items: center;
}

.mic-icon {
  width: 6%;
  margin-left: 3%;
}

.chat-screen .message-input {
  width: 70%;
  height: 35px;
  padding: 5px;
  margin: 5px;
  margin-left: 2%;
}

.upload-label {
  cursor: pointer;
}

.upload-icon {
  width: 8%;
  margin-left: 2%;
}

.file-input {
  display: none;
}

.send-icon {
  width: 8%;
  margin-left: 2%;
  cursor: pointer;
}

.accordion-button {
  position: relative;
  padding-right: 2.5rem; /* Adjust padding as necessary */
}
.accordion-button::after {
  display: none; /* Hide the default caret icon */
}

.custom-toggle {
  position: absolute;
  right: 1rem; /* Adjust positioning as necessary */
  filter: invert(0); /* Default color */
}
.custom-toggle.expanded {
  filter: invert(1); /* Change to white color */
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* Adjust height as needed */
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px;
  animation: bounce 1.5s infinite ease-in-out; /* Adjust animation duration */
}

.red {
  background-color: #f44336;
  animation-delay: 0s; /* No delay for first dot */
}

.green {
  background-color: #4caf50;
  animation-delay: 0.5s; /* Delay for second dot */
}

.blue {
  background-color: #2196f3;
  animation-delay: 1s; /* Delay for third dot */
}

@keyframes bounce {
  0%, 50%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-15px); /* Jump height */
  }
}
.custom-accordion-body {
  background-color: rgb(43, 44, 51); /* Your desired background color */
}

/* ChatInput.scss */
.chat-input-container {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 50px;
  margin-left: 9%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  height: 45px;
  width: 60%;
  border-radius: 18px;
  border: 1px solid white;
}

.chat-input-container1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  height: 31px;
  width: 90%;
  border-radius: 10px;
  border: 1px solid white;
}

.mic-icon {
  width: 14px !important;
  height: auto;
  margin-right: 10px;
  margin-left: 20px;
}

.chat-textarea1 {
  width: 82%;
  height: 30px;
  padding-top: 7px;
  border: none;
  outline: none;
  resize: none;
}

.chat-textarea {
  width: 82%;
  height: 44px;
  padding-top: 7px;
  border: none;
  outline: none;
  resize: none;
}

.chat-input-container .upload-icon {
  width: 14px;
  margin: 0;
  cursor: pointer;
}

.file-input {
  display: none; /* Hide the file input */
}

.send-icon {
  width: 7%;
  height: 30px;
  cursor: pointer;
  background-color: rgb(161, 0, 255);
  border-radius: 20px;
  margin-left: auto;
  margin-right: 15px;
}

.send-icon1 {
  width: 6%;
  height: 25px;
  cursor: pointer;
  background-color: rgb(161, 0, 255);
  border-radius: 20px;
  margin-left: auto;
  margin-right: 15px;
}

.accordion-count {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: linear-gradient(110.71deg, #F76A4B 15.87%, #A24AE7 60.65%, #4859F3 89.14%);
  color: white;
  text-align: center;
  margin-left: 10px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/component/screens/ChatScreen.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AACJ;;AACE;EACE,aAAA;EACA,wCAAA;EACA,YAAA;EACA,mBAAA,EAAA,qBAAA;EACA,SAAA;AAEJ;;AAEE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA,EAAA,qBAAA;EACA,SAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA,EAAA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA,EAAA,gCAAA;EACA,eAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,sBAAA;AACJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA,EAAA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA,EAAA,gCAAA;EACA,eAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,sBAAA;AAEJ;;AACE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;AAEJ;;AACE;EACE,iBAAA;AAEJ;;AACE;EACE,iBAAA;EACA,gBAAA,EAAA,+CAAA;AAEJ;;AACE;EACE,oCAAA;EACA,oIAAA;EACA,qBAAA;AAEJ;;AAAE;EACE,gCAAA;EAEA,qBAAA;AAEJ;;AAAE;;EAEE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;AAGJ;;AAAE,+BAAA;AACA;EACE;IACE,WAAA,EAAA,4CAAA;EAGJ;AACF;AAAE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,2CAAA;AAEJ;;AACE;EACE,mBAAA;EACA,iBAAA;AAEJ;;AACE;EACE,UAAA;EACA,kBAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAEJ;;AACE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAEJ;;AACE;EACE,eAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAEJ;;AACE;EACE,YAAA;AAEJ;;AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAEJ;;AACE;EACE,UAAA;AAEJ;;AACE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;;AACE;EACE,mBAAA;EACA,iCAAA;AAEJ;;AACE;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;AAEJ;;AACE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAEJ;;AACE;EACE,gIAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA,EAAA,6BAAA;EACA,eAAA,EAAA,uCAAA;AAEJ;;AACE;EACE,eAAA;EACA,YAAA;AAEJ;;AACE;EAEE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEE;EACE,SAAA;EACA,eAAA;AACJ;;AAEE;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAEE;EACE,eAAA;AACJ;;AAEE;EACE,SAAA;EACA,eAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,SAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEE;EACE,kBAAA;EACA,qBAAA,EAAA,gCAAA;AACJ;AACI;EACE,aAAA,EAAA,gCAAA;AACN;;AAGE;EACE,kBAAA;EACA,WAAA,EAAA,oCAAA;EACA,iBAAA,EAAA,kBAAA;AAAJ;AAEI;EACE,iBAAA,EAAA,0BAAA;AAAN;;AAIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA,EAAA,4BAAA;AADJ;;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,2CAAA,EAAA,8BAAA;AADJ;;AAIE;EACE,yBAAA;EACA,mBAAA,EAAA,2BAAA;AADJ;;AAIE;EACE,yBAAA;EACA,qBAAA,EAAA,yBAAA;AADJ;;AAIE;EACE,yBAAA;EACA,mBAAA,EAAA,wBAAA;AADJ;;AAIE;EACE;IACE,wBAAA;EADJ;EAGE;IACE,4BAAA,EAAA,gBAAA;EADJ;AACF;AAIE;EACE,iCAAA,EAAA,kCAAA;AAFJ;;AAOE,mBAAA;AAEF;EACI,eAAA;EACF,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;AALJ;;AAQE;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;AANJ;;AAUE;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;;AASE;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AANJ;;AASE;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AANJ;;AASC;EACG,WAAA;EACA,SAAA;EACA,eAAA;AANJ;;AASE;EACE,aAAA,EAAA,wBAAA;AANJ;;AASE;EACE,SAAA;EACA,YAAA;EAEA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUE;EACE,SAAA;EACA,YAAA;EAEA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAUE;EACE,WAAA;EACF,YAAA;EACA,kBAAA;EACA,sFAAA;EAIA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAVF","sourcesContent":[".chat-screen {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 10px;\n    color: rgba(155, 156, 158, 1);\n    font-size: 12px;\n  }\n  .tab-container1 {\n    display: flex;\n    border-bottom: 1px solid rgb(78, 78, 78);\n    height: 40px;\n    margin-bottom: 20px; /* Adjust as needed */\n    gap:20px;\n  }\n\n  \n  .tab-container {\n    display: flex;\n    justify-content: center;\n    height: 30px;\n    margin-bottom: 20px; /* Adjust as needed */\n    gap:20px;\n  }\n  \n  .tab {\n    display: flex;\n    align-items: center;\n    justify-content: center; /* Center align text and icons */\n    cursor: pointer;\n    padding-bottom: 2px;\n    transition: border-bottom 0.3s ease-in-out;\n    width: auto; /* Adjust width to fit content */\n    padding: 0 15px; /* Add padding to make it larger */\n    text-align: center; /* Center align text */\n  }\n  .tab1 {\n    display: flex;\n    align-items: center;\n    justify-content: center; /* Center align text and icons */\n    cursor: pointer;\n    padding-bottom: 2px;\n    transition: border-bottom 0.3s ease-in-out;\n    width: auto; /* Adjust width to fit content */\n    padding: 0 15px; /* Add padding to make it larger */\n    text-align: center; /* Center align text */\n  }\n  \n  .tab:last-child {\n    margin-right: 0;\n    padding-right: 10px;\n    padding-left: 0px;\n  }\n  \n  .tab-icon {\n    margin-right: 5px;\n  }\n  \n  .library-icon {\n    margin-right: 0px;\n    margin-top: 20px; /* Removed margin-top to align with other tab */\n  }\n  \n  .active {\n    border-bottom: 2px solid transparent;\n    border-image: linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%) 1;\n    border-image-slice: 1;\n  }\n  .active1 {\n    border-bottom: 2px solid #A100FF;\n    \n    border-image-slice: 1;\n  }\n  .chat-content,\n  .library-content {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    /* Additional styles for content */\n  }\n  \n  /* Responsive design for tabs */\n  @media (min-width: 768px) {\n    .tab {\n      width: auto; /* Tabs will now expand and fill the space */\n    }\n  }\n\n  .chat-messages {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    overflow-y: scroll;\n    height: 54vh;\n    padding-left: 6%;\n  }\n  \n  .message-row {\n    display: flex;\n    flex-direction: row;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(161, 161, 161, 1);\n  }\n  \n  .message-row.user-message {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  \n  .message-content {\n    width: 65%;\n    margin-right: 30px;\n  }\n  \n  .message-info {\n    display: flex;\n    flex-direction: row;\n    margin-top: 1%;\n    border: 1px solid #4E4E4E;\n    border-radius: 10px;\n    padding-top: 1%;\n    align-items: flex-start;\n  }\n  \n  .avatar {\n    width: 30px;\n    padding-left: 10px;\n    margin-top: 5px;\n  }\n  \n  .sender-name {\n    margin-left: 2%;\n    color: rgba(155, 156, 158, 1);\n    font-size: 12px;\n    margin-top: 5px;\n  }\n\n  .formatted-message {\n    color: white;\n  }\n  \n  .message-text {\n    padding: 5px 0;\n    font-size: 10px;\n    text-align: left;\n    font-family: Graphik;\n  }\n  \n  .message-meta {\n    width: 30%;\n  }\n  \n  .accordions {\n    margin-top: -55px;\n    max-height: 45vh;\n    overflow-y: scroll;\n  }\n  \n  .meta-accordion {\n    margin-bottom: 10px;\n    background-color: rgb(43, 44, 51);\n  }\n  \n  .accordion-title {\n    font-size: 10px;\n    text-align: center;\n    font-family: Graphik;\n  }\n  \n  .expand-button {\n    background: none;\n    border: none;\n    margin-left: 250px;\n  }\n  \n  .document-button {\n    background: linear-gradient(to right, rgba(246, 106, 75, 1) 0%, rgba(246, 106, 75, 1) 30%, rgba(162, 74, 231, 1) 60%, rgba(72, 89, 243, 1) 100%);\n    font-size: 10px;\n    border: 1px solid rgb(26, 29, 33);\n    border-radius: 15px;\n    color: white;\n    margin: 2px;\n    padding: 5px 10px; /* Adjust padding as needed */\n    cursor: pointer; /* Add cursor pointer for interaction */\n  }\n  \n  .recommendation-text {\n    font-size: 10px;\n    color: white;\n  }\n  \n  .input-row {\n   // background-color: white;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    margin-top: 10px;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .mic-icon {\n    width: 6%;\n    margin-left: 3%;\n  }\n  \n  .chat-screen .message-input {\n    width: 70%;\n    height: 35px;\n    padding: 5px;\n    margin: 5px;\n    margin-left: 2%;\n  }\n  \n  .upload-label {\n    cursor: pointer;\n  }\n  \n  .upload-icon {\n    width: 8%;\n    margin-left: 2%;\n  }\n  \n  .file-input {\n    display: none;\n  }\n  \n  .send-icon {\n    width: 8%;\n    margin-left: 2%;\n    cursor: pointer;\n  }\n  \n  .accordion-button {\n    position: relative;\n    padding-right: 2.5rem; /* Adjust padding as necessary */\n  \n    &::after {\n      display: none; /* Hide the default caret icon */\n    }\n  }\n  \n  .custom-toggle {\n    position: absolute;\n    right: 1rem; /* Adjust positioning as necessary */\n    filter: invert(0); /* Default color */\n  \n    &.expanded {\n      filter: invert(1); /* Change to white color */\n    }\n  }\n  \n  .loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px; /* Adjust height as needed */\n  }\n  \n  .dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin: 0 5px;\n    animation: bounce 1.5s infinite ease-in-out; /* Adjust animation duration */\n  }\n  \n  .red {\n    background-color: #f44336;\n    animation-delay: 0s; /* No delay for first dot */\n  }\n  \n  .green {\n    background-color: #4caf50;\n    animation-delay: 0.5s; /* Delay for second dot */\n  }\n  \n  .blue {\n    background-color: #2196f3;\n    animation-delay: 1s; /* Delay for third dot */\n  }\n  \n  @keyframes bounce {\n    0%, 50%, 100% {\n      transform: translateY(0);\n    }\n    25% {\n      transform: translateY(-15px); /* Jump height */\n    }\n  }\n  \n  .custom-accordion-body {\n    background-color: rgb(43, 44, 51); /* Your desired background color */\n  }\n  \n\n  //input\n  /* ChatInput.scss */\n\n.chat-input-container {\n    position: fixed;\n  bottom: 0;\n  left: 0;\n  margin: 50px;\n  margin-left: 9%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: white;\n    height: 45px;\n    width: 60%;\n    border-radius: 18px;\n    border: 1px solid white;\n    \n  }\n  .chat-input-container1 {\n   \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: white;\n    height: 31px;\n    width: 90%;\n    border-radius: 10px;\n    border: 1px solid white;\n    \n  }\n  \n  .mic-icon {\n    width: 14px !important;\n    height: auto;\n    margin-right: 10px;\n    margin-left: 20px;\n  }\n  .chat-textarea1 {\n    width: 82%;\n    height: 30px;\n    padding-top: 7px;\n    border: none;\n    outline: none;\n    resize: none;\n  }\n  \n  .chat-textarea {\n    width: 82%;\n    height: 44px;\n    padding-top: 7px;\n    border: none;\n    outline: none;\n    resize: none;\n  }\n  \n .chat-input-container .upload-icon {\n    width: 14px;\n    margin: 0;\n    cursor: pointer;\n  }\n  \n  .file-input {\n    display: none; /* Hide the file input */\n  }\n  \n  .send-icon {\n    width: 7%;\n    height: 30px;\n    //margin: 7px 20px 0 15px;\n    cursor: pointer;\n    background-color: rgb(161, 0, 255);\n    border-radius: 20px;\n    margin-left: auto;\n    margin-right: 15px;\n  }\n\n  .send-icon1 {\n    width: 6%;\n    height: 25px;\n    //margin: 7px 20px 0 15px;\n    cursor: pointer;\n    background-color: rgb(161, 0, 255);\n    border-radius: 20px;\n    margin-left: auto;\n    margin-right: 15px;\n  }\n  .accordion-count{\n    width: 19px;\n  height: 19px;\n  border-radius: 50%;\n  background: linear-gradient(110.71deg, #F76A4B 15.87%, #A24AE7 60.65%, #4859F3 89.14%);\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n  color: white;\n  text-align: center;\n  margin-left: 10px;\n  font-size: 14px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
